export default __webpack_public_path__ + "static/media/wa_0.f89f6ecc.mp3";